import { LOADING_STATUS } from '../../../shared/constants/loadingStatus';

export function getCreateTemplateInitialLoadingChecks({
  apiReady,
  campaignsStatus,
  tagsStatus,
  triggersStatus,
  variablesStatus,
  disclosuresStatus,
}) {
  const ready = Boolean(apiReady);

  return {
    shouldLoadCampaigns: ready && campaignsStatus === LOADING_STATUS.IDLE,
    shouldLoadTags: ready && tagsStatus === LOADING_STATUS.IDLE,
    shouldLoadTriggers: ready && triggersStatus === LOADING_STATUS.IDLE,
    shouldLoadVariables: ready && variablesStatus === LOADING_STATUS.IDLE,
    shouldLoadDisclosures: ready && disclosuresStatus === LOADING_STATUS.IDLE,
  };
}
